import React from 'react';
import Anchor from '../../../../../../components/link/Anchor';
import ExcelUploadForm from '../../../../../../components/form/ExcelUploadForm';
import Section from '../../../../../../components/outline/Section';
import { PRODUCT_UPDATE_TEMPLATE_XLSX_URL } from '../../../../../../constants/service/common/staticFileUrlConstants';
import { EXCEL_UPLOAD_TYPE } from '../../../../../../constants/service/common/utilConstants';
import './ProductExcelBulkEditSummaryBox.scss';

const ProductExcelBulkEditSummaryBox = (props) => {
  const { file, bulkEditProductValidResultCount, onChange } = props;
  const { total, success, failed } = bulkEditProductValidResultCount;

  return (
    <Section className="product-excel-bulk-edit-summary-box">
      <div className="summary-area">
        <div className="bulk-edit-summary-area">
          <div>요청 : {total}</div>
          <div className="valid">가능 : {success}</div>
          <div className="invalid">불가능 : {failed}</div>
        </div>

        <Anchor
          className="template-download"
          text="일괄 편집 양식 다운"
          isUnderLine={true}
          color="primary"
          href={PRODUCT_UPDATE_TEMPLATE_XLSX_URL}
          target="_blank"
        />
      </div>

      <div className="description-area">
        {!total ? <div>* 엑셀 파일을 업로드해주세요.</div> : null}
        {success && !failed ? (
          <div className="valid">
            <div>요청하신 {success}개 상품은 모두 일괄 편집 가능합니다.</div>
            <div>일괄 편집을 하시려면 수정하기 버튼을 클릭해주세요.</div>
          </div>
        ) : null}
        {failed ? (
          <div className="invalid">
            <div>상품 일괄 편집을 실패하였습니다.</div>
            <div>결과 내역을 확인하시고, 엑셀 파일을 수정한 후 재 업로드하시기 바랍니다.</div>
          </div>
        ) : null}
      </div>

      <ExcelUploadForm
        uploadType={EXCEL_UPLOAD_TYPE.DRAG_DROP}
        fileName={file ? file.name : null}
        onChange={(file) => onChange(file)}
      />
    </Section>
  );
};

export default ProductExcelBulkEditSummaryBox;
